<template>
  <div class="p-profile-collection">
    <CommonHeader />
    <main>
      <JoLoadMore
        ref="loadmore"
        @onRefresh="onRefresh"
        @onLoadMore="onLoadMore"
      >
        <ul class="feed-list">
          <li
            v-for="(card, index) in list"
            :key="`post-${card.id}-${index}`"
            :data-feed-id="card.id"
          >
            <PostCard
              v-if="card.user_id"
              :post="card"
              :collect="true"
              @unCollect="handleCancelCollect"
            />
          </li>
        </ul>
      </JoLoadMore>
    </main>
  </div>
</template>

<script>
  import i18n from '@/i18n'
  import { limit } from '@/api'
  import * as api from '@/api/group'
  import PostCard from '@/page/group/components/PostCard.vue'

  export default {
    name: 'ProfileCollection',
    components: { PostCard },
    data () {
      return {
        list: [],
      }
    },
    activated () {
      this.$refs.loadmore.beforeRefresh()
    },
    mounted () {
      // this.$matomoTrackPageView(`我的收藏 - 旭辉员工论坛（SPA）`)
    },
    methods: {
      onRefresh () {
        api.getCollectionPosts().then(({ data }) => {
          this.list = data
          this.$refs.loadmore.afterRefresh(data.length < limit)
        })
      },
      onLoadMore () {
        const offset = this.list.length
        api.getCollectionPosts({ offset }).then(({ data }) => {
          this.list = [...this.list, ...data]
          this.$refs.loadmore.afterLoadMore(data.length < limit)
        })
      },
      // 取消收藏时 从列表中移除
      handleCancelCollect (id) {
        const { list } = this
        this.$set(this, 'list', list.filter(post => post.id !== id))
      },
    },
  }
</script>
<style lang="less">
.feed-list {
  background: #f7f7f7;

  li {
    margin-bottom: 20px;
  }
}
</style>
